jQuery(document).ready ($) ->
	$accordion = $ '.accordion-box'
	unless $accordion.length > 0
		return

	isPopup = !_.isUndefined $accordion.data 'popup'

	$accordionItems = $accordion.find 'li'
	$accordionControl = $accordion.find '.control'
	$accordionContent = $accordion.find '.content'

	$accordionControl.on 'click', (e) ->
		e.preventDefault()

		$this = $ this
		$accordionCurrentItem = $this.parent()
		$accordionCurrentContent = $accordionCurrentItem.find '.content'

		isActive = $accordionCurrentItem.hasClass 'is-active'

		unless isPopup
			$accordionItems.removeClass 'is-active'

		$accordionCurrentItem.addClass 'is-active'

		unless isPopup
			$accordionContent.stop(true).slideUp 400, ->
				$accordionCurrentItem.removeClass 'is-active'
		else
			if isActive
				$accordionCurrentContent.stop(true).slideUp 400, ->
					$accordionCurrentItem.removeClass 'is-active'

		unless isActive
			$accordionCurrentContent.stop(true).slideDown 400, ->
				$accordionCurrentItem.addClass 'is-active'

	$accordionControl.first().click()


/** WEBPACK FOOTER **
 ** ./assets/coffee/modules/accordion.coffee
 **/